import { createAction, createReducer } from '@reduxjs/toolkit';
import frc from 'front-end-common';
import AccountsService from '../Services/AccountsService';

const { addDefaultHandlers, getDefaultState } = frc.utils.reducerTools;

export const accountsListFetch = createAction('accounts/list', (params) => ({
  payload: AccountsService.getAccountsList(params),
}))

export const accountsListToCreateFetch = createAction('accounts/to-create-list', (params) => ({
  payload: AccountsService.getAccountsToCreateList(params),
}))

export const balancesListFetch = createAction('accounts/balances', () => ({
  payload: AccountsService.fetchBalancesList(),
}))

export const createAccount = createAction('account/create', (data) => ({
  payload: AccountsService.createAccount(data),
}))

export const createAccounts = createAction('accounts/create', (data) => ({
  payload: AccountsService.createAccounts(data),
}))

export const fetchAuxAccount = createAction('accounts/fetch-aux', () => ({
  payload: AccountsService.fetchAux(),
}))

export const fetchAccountsGroups = createAction('accounts/groups', () => ({
  payload: AccountsService.fetchAccountsGroups(),
}));

export const updateAccounts = createAction('accounts/updates', (data) => ({
  payload: AccountsService.updateAccountsOld(data),
}));

export const updateAccount = createAction('accounts/update', (data) => ({
  payload: AccountsService.updateAccount(data),
}));

export const groupChangeAccounts = createAction('accounts/group-edit', (data) => ({
  payload: AccountsService.groupEditAccounts(data),
}));

export const downloadAccounts = createAction('accounts/download', () => ({
  payload: AccountsService.downloadAccountsList(),
}));

export const getCurrenciesList = createAction('accounts/currencies', () => ({
  payload: AccountsService.getCurrencies(),
}));

export const getAccountsPoolInfo = createAction('accounts/pool-info', () => ({
  payload: AccountsService.getPoolInfo(),
}));

export const canBuyRequest = createAction('accounts/can-buy', (data) => ({
  payload: AccountsService.requestCanBuy(data),
}));

export const purchase = createAction('accounts/purchase', (data) => ({
  payload: AccountsService.purchase(data),
}));

export const removeUserDataDir = createAction('drivers/remove-chrome-profile', (accountId) => ({
  payload: AccountsService.removeUserDataDir(accountId),
}));

export const unsubscribePassUser = createAction('accounts/unsubscribe-full', (accountId) => ({
  payload: AccountsService.unsubscribePassFull(accountId),
}));

export const findAndSetProxy = createAction('accounts/set-proxy', (accountId) => ({
  payload: AccountsService.setAccountProxy(accountId)
}));

export const setVmGroup = createAction('accounts/set-vm-group', (accountId, groupName) => ({
  payload: AccountsService.setVmGroup(accountId, groupName)
}));

export const accessInfo = createAction('accounts/account-access-info', (accountId) => ({
  payload: AccountsService.accessAccountInfo(accountId),
}));

export const sendUserToFarmRewards = createAction('accounts/farm-rewards', (accountId) => ({
  payload: AccountsService.sendToFarmRewards(accountId),
}));

const initState = {
  list: getDefaultState(),
  toCreateList: getDefaultState(),
  balances: getDefaultState(),
  create: getDefaultState(),
  createAccounts: getDefaultState(),
  aux: getDefaultState(),
  accountsGroups: getDefaultState(),
  updates: getDefaultState(),
  groupEdit: getDefaultState(),
  update: getDefaultState(),
  download: getDefaultState(),
  currencies: getDefaultState(),
  poolInfo: getDefaultState(),
  canBuy: getDefaultState(),
  purchase: getDefaultState(),
  deleteDataUser: getDefaultState(),
  unsubscribeFull: getDefaultState(),
  setProxy: getDefaultState(),
  accountAccessInfo: getDefaultState(),
  farmRewards: getDefaultState()
};

export default createReducer(initState, (builder) => {
  addDefaultHandlers(builder, accountsListFetch, 'list');
  addDefaultHandlers(builder, accountsListToCreateFetch, 'toCreateList');
  addDefaultHandlers(builder, balancesListFetch, 'balances');
  addDefaultHandlers(builder, createAccount, 'create');
  addDefaultHandlers(builder, createAccounts, 'createAccounts');
  addDefaultHandlers(builder, fetchAuxAccount, 'aux');
  addDefaultHandlers(builder, fetchAccountsGroups, 'accountsGroups');
  addDefaultHandlers(builder, updateAccounts, 'updates');
  addDefaultHandlers(builder, groupChangeAccounts, 'groupEdit');
  addDefaultHandlers(builder, updateAccount, 'update');
  addDefaultHandlers(builder, downloadAccounts, 'download');
  addDefaultHandlers(builder, getCurrenciesList, 'currencies');
  addDefaultHandlers(builder, getAccountsPoolInfo, 'poolInfo');
  addDefaultHandlers(builder, canBuyRequest, 'canBuy');
  addDefaultHandlers(builder, purchase, 'purchase');
  addDefaultHandlers(builder, removeUserDataDir, 'deleteDataUser');
  addDefaultHandlers(builder, unsubscribePassUser, 'unsubscribeFull');
  addDefaultHandlers(builder, findAndSetProxy, 'setProxy');
  addDefaultHandlers(builder, setVmGroup, 'setVmGroup');
  addDefaultHandlers(builder, accessInfo, 'accountAccessInfo');
  addDefaultHandlers(builder, sendUserToFarmRewards, 'farmRewards');
});
